import { render, staticRenderFns } from "./TransferOwnAccount.vue?vue&type=template&id=2a0387a6&scoped=true"
import script from "./TransferOwnAccount.vue?vue&type=script&lang=js"
export * from "./TransferOwnAccount.vue?vue&type=script&lang=js"
import style0 from "./TransferOwnAccount.vue?vue&type=style&index=0&id=2a0387a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0387a6",
  null
  
)

export default component.exports